import React from 'react';
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <header className="bg-light py-3">
      <div className="container text-center">
        <Link to="/">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" className="img-fluid" style={{ maxWidth: '70px', maxHeight: '70px', cursor: 'pointer' }} />
        </Link>
      </div>
    </header>
  );
};

export default Header;